import ThailandAutoComplete from 'vue-thailand-address-autocomplete'
import api from '../../services/service_item'
export default {
  components: {
    ThailandAutoComplete
  },
  data () {
    return {
      title: 'จัดการสินค้า',
      search: '',
      currentPage: 1,
      items_perpage: 10,
      active: 1,
      modal_active: false,
      modal_data: {
        name: '',
        credit_day: 0,
        debt_limit: 0,
        debt_balance: 0,
        telephone: '',
        address: '',
        sub_district: '',
        district: '',
        province: '',
        zipcode: '',
        active_status: ''
      },
      modal_title: '',
      data_list: [],
      menu_active: 0,
      menus: [
        {name: 'menu1'},
        {name: 'menu2'},
        {name: 'menu3'},
        {name: 'menu4'},
        {name: 'menu5'}
      ],
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      group: [],
      data_list_group: []
    }
  },
  computed: {
    filterData: function () {
      let text = this.search.trim()
      this.currentPage = 1
      return this.data_list.filter(items => {
        return (
          items.code.indexOf(text) > -1 || items.name.indexOf(text) > -1
        )
      })
    },
    paginate: function () {
      this.totalItem = this.filterData.length
      if (this.currentPage >= this.totalPages) {
        this.currentPage = Math.max(0, this.totalPages - 1)
      }
      var index = (this.currentPage - 1) * this.items_perpage
      return this.filterData.slice(index, index + this.items_perpage)
    }
  },
  methods: {
    itemRender (current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    status_is_process (val) {
      switch (val) {
        case 1:
          return 'กำลังคำนวน'
        case 0:
          return 'สำเร็จ'
        default:
          return 'ไม่พบสถานะ'
      }
    },
    onChange (pageNumber) {
      this.active = pageNumber
    },
    goToPage (path, id) {
      this.$store.state.historyPage = this.$route.path
      this.$router.push({ name: path, params: { id: id } })
    },
    doing () {
      alert('รอดำเนินการ')
    },
    select (address) {
      this.modal_data.sub_district = address.district
      this.modal_data.district = address.amphoe
      this.modal_data.province = address.province
      this.modal_data.zipcode = address.zipcode
    },
    close_modal () {
      this.modal_active = false
      this.modal_data = {
        name: '',
        credit_day: 0,
        debt_balance: 0,
        telephone: '',
        address: '',
        sub_district: '',
        district: '',
        province: '',
        zipcode: '',
        active_status: ''
      }
    },
    getProductAll () {
      this.$store.commit('Loading')
      api.listProduct(this.REST_URL,
        this.header,
        {},
        result => {
          // console.log(result)
          if (result.response === 'success') {
            this.data_list = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลสินค้า',
              description:
                result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    editItem (val) {
      console.log(val.id)
      this.goToPage('manageitem', val.id)
    },
    getGroup () {
      api.itemGroup(this.REST_URL,
        this.header,
        {},
        result => {
          // console.log(result)
          if (result.response === 'success') {
            this.group = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลกลุ่มสินค้าไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    ListByGroup () {
      this.$store.commit('Loading')
      api.itemsALLGroup(this.REST_URL,
        this.header,
        {},
        result => {
          if (result.response === 'success') {
            this.data_list_group = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลสินค้า',
              description:
                result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    selectByGroup (index) {
      this.data_list = this.data_list_group[index].items
      if (this.data_list_group[index].items == null) {
        this.data_list = []
      } else {
        this.data_list = this.data_list_group[index].items
      }
    }
  },
  created () {
    this.getGroup()
    this.ListByGroup()
  },
  mounted () {
    this.checkUser()
    this.$store.state.historyPage = ''
    this.getProductAll()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/item_list.js